import {
  ABILITY_CLEANING_REPORT,
  ABILITY_CLEANING_MAP,
} from '@/consts/ability';
import { isRoleHonsha, isRoleKyoku } from '@/lib/roleHelper';
import { isAnyDriver } from '@/lib/userAffiliation';
import {
  isJohaisetsuRoleHonsha,
  isJohaisetsuRoleKyoku,
} from '@/lib/johaisetsu/johaisetsuRoleHelper';
import { Lov } from '@/models/apis/master/masterResponse';

const PC_TOP_URL = '/';
const externalReportsRedirectMappings: Record<string, string> = {
  'external_reports_standard': '/sp/external-reports/standard',
  'external_reports_hokkaido_airport': '/sp/external-reports/hokkaido-airport',
  'external_reports_emergency_response_team': '/sp/external-reports/emergency-response-team',
};
const redirectMappings: Record<string, string> = {
  'pc_top': PC_TOP_URL,
  'sp_top': '/sp',
  'johaisetsu_sp_sagyou': '/sp/johaisetsu-sagyou',
  'cleaning_map': '/cleaning',
  'cleaning_sp_report': '/sp/cleaning-report',
  ...externalReportsRedirectMappings,
  '': PC_TOP_URL,
};

export function filterDefaultPagesByJohaisetsuRole(defaultPagesOrig: Lov[], role: string | null): Lov[] {
  const johaisetsuPages = defaultPagesOrig.filter(e => e.key.startsWith('johaisetsu_'));
  if (!role) return [];

  if (isJohaisetsuRoleHonsha(role) || isJohaisetsuRoleKyoku(role)) {
    return johaisetsuPages.filter(e => !e.key.startsWith('johaisetsu_sp_'));
  }
  if (isAnyDriver(role)) {
    return johaisetsuPages.filter(e => e.key.startsWith('johaisetsu_sp_'));
  }
  return [];
}

export function filterDefaultPagesByCleaningRole(defaultPagesOrig: Lov[], role: string | null): Lov[] {
  const cleaningPages = defaultPagesOrig.filter(e => e.key.startsWith('cleaning_'));
  if (!role) return [];

  if (isRoleHonsha(role) || isRoleKyoku(role)) {
    return cleaningPages.filter(e => !e.key.startsWith('cleaning_sp_'));
  }
  if (isAnyDriver(role)) {
    return cleaningPages.filter(e => e.key.startsWith('cleaning_sp_'));
  }
  return [];
}

export function filterDefaultPagesByAbilityIds(defaultPages: Lov[], abilityIds: number[]): Lov[] {
  let ret = defaultPages;
  if (!abilityIds.includes(ABILITY_CLEANING_MAP)) {
    ret = ret.filter(e => e.key !== 'cleaning_map');
  }
  if (!abilityIds.includes(ABILITY_CLEANING_REPORT)) {
    ret = ret.filter(e => e.key !== 'cleaning_sp_report');
  }
  return ret;
}
interface RedirectDefaultPageUrlParams {
  useJohaisetsuOnly: boolean;
  useCleaningOnly: boolean;
  defaultPage: string;
}

export function getRedirectDefaultPageUrl(params: RedirectDefaultPageUrlParams): string {
  if (params.useJohaisetsuOnly) {
    return '/settou-message-board';
  }
  if (params.useCleaningOnly) {
    return '/cleaning-map';
  }
  // デフォルト画面は必須項目なので見つからない場合はログインページにリダイレクト
  return redirectMappings[params.defaultPage] || '/login';
}
